<div
  class="sidebar-item"
  (click)="onClick()"
  [hidden]="item.hidden()"
  [class.active]="item.isActive()"
  (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false"
>
  @if (item.icon) {
  <a360-icon
    [icon]="item.icon"
    [color]="item.isActive() || (isHovered && !isMobileDevice) ? iconColors.LIGHT_ORANGE : iconColors.WHITE"
    [isHoverEnable]="!isMobileDevice"
    [text]="!isCollapsed ? item.name : ''"
    [style]="item.style"
  ></a360-icon>
  } @if (!item.icon) {
  <span class="txt">{{ item.name }}</span>
  } @if (count > 0) {
  <div class="count-label">{{ count }}</div>
  }
</div>
